import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { Redirect } from "@/components/Routing/Redirect";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canManageEvents } from "@/helpers/permissions";
import { canListEvents } from "@/modules/events/permissions";
import { routes } from "@/routes";

import { eventsRoutes } from "./routes";

export const eventsRoute = [
  {
    path: "",
    element: <Redirect to={routes.calendar.list} />,
  },
  {
    path: eventsRoutes.create,
    lazy: async () => {
      const { CreateEventPage } = await import("@/modules/events/pages/event-editor/CreateEventPage");

      return {
        element: (
          <RequireAuth permission={canManageEvents}>
            <CreateEventPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: eventsRoutes.edit,
    lazy: async () => {
      const { EditEventPage } = await import("@/modules/events/pages/event-editor/EditEventPage");

      return {
        element: (
          <RequireAuth permission={canManageEvents}>
            <EditEventPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: eventsRoutes.details,
    lazy: async () => {
      const { EventDetailsPage } = await import("@/modules/events/pages/event-details/EventDetailsPage");

      return {
        element: (
          <RequireAuth permission={canListEvents}>
            <EventDetailsPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
